import { sendPost } from "./axios";

// eslint-disable-next-line import/prefer-default-export
export const signin = (payload: any) =>
  sendPost("/api-client/auth/login", payload);

export const logoutApi = (payload: any) =>
  sendPost("/api-client/auth/logout", payload);
